import { useIdentity } from '@interhyp/platform-auth';
import { DefinedRoute, useFilteredRoutes } from '@interhyp/platform-router';
import { useMemo } from 'react';

import { COMPANY_ID_INTERHYP } from '../constants/companies';

interface LocalDefinedRoute extends DefinedRoute {
  label: string;
}

export function useMainNavigation(): LocalDefinedRoute[] {
  const identity = useIdentity();
  const routes = useMemo(
    () => [
      ...(identity?.companyId !== COMPANY_ID_INTERHYP && identity?.userType === 'CUSTOMER'
        ? [
            {
              label: 'Dashboard',
              path: '/',
              exact: true,
            },
          ]
        : []),
      {
        label: 'Nachrichten',
        path: '/nachrichten',
        exact: false,
      },
      {
        label: 'Tutorials',
        path: '/tutorials',
        exact: true,
      },
    ],
    [identity?.companyId, identity?.userType],
  );

  return useFilteredRoutes(routes);
}
